import React, {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';

import {activeNotificationsSelector} from 'src/modules/internal-notification';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import {Notify} from '@pb/kit-component-notify';


import type {Notification} from 'src/openapi/admin/models/Notification';

type Props = {
    notification: Notification,
};

export const NotificationLink = ({notification}: Props) => {
    const queryParams = useParams<{notificationId: string}>();
    const navigate = useNavigate();

    const notificationsResponse = useSelector(activeNotificationsSelector);

    const openNotification = useCallback(() => {
        navigate(`/internal-notification/my-notifications/${notification.notificationId}`, {replace: true});
    }, [navigate, notification]);

    const isActive = useMemo(() => {
        return !!(notificationsResponse?.data && notificationsResponse.data.some(
            item => item.notificationId === notification.notificationId,
        ));
    }, [notificationsResponse, notification]);

    return (
        <Group alignItems="center" gap="s" style={{width: 300}}>
            {queryParams.notificationId === notification.notificationId
                ? <Icon type={Icons.CARET_RIGHT}/>
                : null}
            <a key={notification.notificationId} onClick={openNotification} style={{maxWidth: 280}}>
                <EllipsisTextHint title={notification.title}>
                    {notification.title}
                </EllipsisTextHint>
            </a>
            {isActive ? <Notify/> : null}
        </Group>
    );
};
